import { useState } from 'react';
import { FormCheckbox } from '~/components/FormComponents/FormCheckbox.tsx';
import { Box, Button, Grid, Typography } from '@mui/material';
import { styles } from '~/modules/auth/styles.ts';
import { useFormContext } from 'react-hook-form';
import { consentToDataProcessing } from '~/modules/auth/constants.ts';
import { commonStyles } from '~/theme/styles/commonStyles';
import { BaseModal } from '~/components/modals/BaseModal/BaseModal.tsx';

export const ConsentToDataProcessing = () => {
  const { trigger } = useFormContext();
  const [isOpened, setIsOpened] = useState(false);

  const checkConsentDataProcessing = () => {
    setIsOpened(true);
    trigger('checkConsentToDataProcessing');
  };

  const closeModal = () => setIsOpened(false);
  return (
    <Grid>
      <FormCheckbox
        label="Згода на обробку персональних даних, у т.ч. підтвердження наявності згоди інших осіб, чиї дані також передаються"
        name="checkConsentToDataProcessing"
        onChange={checkConsentDataProcessing}
      />
      <BaseModal
        open={isOpened}
        onClose={closeModal}
        containerProps={{ sx: styles.modalContainer }}
      >
        <Grid sx={styles.modalContent}>
          <Typography variant={'h4'} sx={styles.modalContentTitle}>
            Згода на обробку даних
          </Typography>
          <Box sx={{ ...commonStyles.columnFlexContainer, gap: 1.5 }}>
            {consentToDataProcessing.map((text, i) => (
              <Box key={i} sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start', p: 1 }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 14,
                  }}
                ></Box>
                <Typography variant="body2" sx={{ lineHeight: 1.65 }}>
                  {text}
                </Typography>
              </Box>
            ))}
          </Box>
        </Grid>
        <Button variant="contained" sx={{ alignSelf: 'center' }} onClick={closeModal}>
          Підтверджую
        </Button>
      </BaseModal>
    </Grid>
  );
};
